export const GET_MY_WEB_ORDERS_PENDING = 'GET_MY_WEB_ORDERS_PENDING'
export const GET_MY_WEB_ORDERS_SUCCESSFUL = 'GET_MY_WEB_ORDERS_SUCCESSFUL'
export const GET_MY_WEB_ORDERS_ERROR = 'GET_MY_WEB_ORDERS_ERROR'
